export class DocumentSaveCaseTeethModel {
  patientId: string;
  documentId: string;
  parentDocumentId: string;
  oldPatientCaseId: string;
  newPatientCaseId: string;
  selectedCaseWorkItemTeeth: SelectedCaseWorkItemTeeth[] = [];
}

export class SelectedCaseWorkItemTeeth {
  selectedCaseWorkItemTeethId: string;
  ToothID: string;  
}
